import TrelloModel from 'app/scripts/models/internal/trello-model.coffee';

class NotificationGroup extends TrelloModel {
  static initClass() {
    this.prototype.typeName = 'NotificationGroup';
    this.prototype.urlRoot = '/1/notificationGroups';
  }
}
NotificationGroup.initClass();

export { NotificationGroup };
